// extracted by mini-css-extract-plugin
export var container = "_63-0";
export var icon = "_63-1";
export var text = "_63-2";